module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"title":"Informe seu e-mail, em instantes você irá receber uma mensagem com o Link de recuperação de senha","busy":"Enviando e-mail","action":"Recuperar senha","call":"Ainda não possuo cadastro.","register":"Cadastre-se agora.","success":"Verifique a sua caixa de e-mail e siga os passos para recuperar a senha"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Auth/Reset.vue
// module id = 125
// module chunks = 0